<script setup>
import { Menu, MenuButton, MenuItems } from '@headlessui/vue';
import Indicator from '@/components/layout/header/Indicator';
</script>

<template>
  <Menu as="div" class="relative w-full flex items-center h-full" v-slot="{ open, close }">
    <MenuButton class="mx-1 h-full ring-inset">
      <slot name="button" :open="open"></slot>
    </MenuButton>
    <MenuItems class="bg-white absolute -right-4 shadow-lg top-full -mt-4 min-w-56 z-50 outline-hidden">
      <Indicator class="absolute -top-2 right-6 text-br-green-light" />
      <div class="bg-br-green-light fluid-xs leading-tightest px-5 py-px">
        <slot name="header" />
      </div>

      <slot :close="close"></slot>
    </MenuItems>
  </Menu>
</template>
